import Sortable from "sortablejs/modular/sortable.core.esm.js"
import { reorderStepIngredientsMutation } from "../components/ingredients/gql"

export default function ingredientsSortable({
  service_slug: serviceSlug,
  step_type: stepType,
  step_type_module_name: stepTypeModuleName,
}) {
  function reorderIngredients() {
    let sortedIngredientsIds = []
    document.querySelectorAll(".ingredient-list li").forEach(triggerField => {
      sortedIngredientsIds.push(triggerField.dataset["ingredientId"])
    })

    reorderStepIngredientsMutation(serviceSlug, stepType, stepTypeModuleName, sortedIngredientsIds)
      .then(() => {
        App.Scripts.partners.displayFlash("Ingredients reordered")
      })
      .catch(() => {
        App.Scripts.partners.displayFlash("There has been an error reordering the ingredients, try again!", "error")
      })
  }

  const ingredientsEl = document.getElementById("ingredient-input-list")
  return Sortable.create(ingredientsEl, {
    animation: 150,
    onUpdate: reorderIngredients,
  })
}
